import type { HelpFile } from '../../types/help'
import { IdentityGrantsDetailTestIds } from '../../../testids/IdentityGrantsDetailTestIds'

export const identityGrantsDetailHelp: HelpFile = {
  docPage: '/docs/analytics/effective-access',
  texts: {
    [IdentityGrantsDetailTestIds.identityGrantsDetailPage]: 'Effective access grants for a single identity — every operation the identity can perform on every resource, with the source assignments that contributed.',
    [IdentityGrantsDetailTestIds.btnRecalculate]: 'Recalculate effective access for this identity after access changes that have not yet been recomputed.',
    [IdentityGrantsDetailTestIds.cardTitleActiveGrants]: null,
    [IdentityGrantsDetailTestIds.cardTitleEffectiveAccessGrants]: 'Detailed list of every effective access grant: resource, operation, environment, and the source assignments that contributed.',
    [IdentityGrantsDetailTestIds.cardTitleLastCalculated]: null,
    [IdentityGrantsDetailTestIds.cardTitleTotalGrants]: null,
    [IdentityGrantsDetailTestIds.colEnforcementObject]: 'Enforcement object — the system-specific entity (group, role, ACL entry) that grants the access.',
    [IdentityGrantsDetailTestIds.colEnvironment]: 'Environment in which the access applies, e.g. production or test.',
    [IdentityGrantsDetailTestIds.colExpand]: null,
    [IdentityGrantsDetailTestIds.colOperation]: 'Operation permitted by this grant, e.g. read, write, or delete.',
    [IdentityGrantsDetailTestIds.colResource]: null,
    [IdentityGrantsDetailTestIds.colSourceAccessProfile]: 'Access profile that delivered this grant.',
    [IdentityGrantsDetailTestIds.colSourceAssignmentExpires]: 'When the source assignment that delivered this grant expires.',
    [IdentityGrantsDetailTestIds.colSourceAssignmentStart]: 'When the source assignment that delivered this grant became effective.',
    [IdentityGrantsDetailTestIds.colSourceCreatedAt]: 'When the source assignment was created.',
    [IdentityGrantsDetailTestIds.colStatus]: 'Status of the grant, e.g. active or expired.',
    [IdentityGrantsDetailTestIds.colTargetSystem]: null,
    [IdentityGrantsDetailTestIds.colValidFrom]: null,
    [IdentityGrantsDetailTestIds.colValidTo]: null,
    [IdentityGrantsDetailTestIds.filterEnvironment]: null,
    [IdentityGrantsDetailTestIds.filterSystem]: null,
    [IdentityGrantsDetailTestIds.linkIdentityDetails]: null,
  },
}
